import * as React from 'react';
import Checkbox from '@mui/material/Checkbox';
import { Tooltip } from '@mui/material';

interface Props {
	id?: string;
	isChecked: boolean;
	handleChange: any;
	[prop: string]: any;
}

export default function CustomCheckbox({ id, isChecked, handleChange, ...props }: Props) {
	return (
		<Checkbox
			id={id}
			checked={isChecked ? isChecked : false}
			onChange={handleChange}
			{...props}
			inputProps={{ 'aria-label': 'controlled' }}
			sx={{
				transition: '0.5s ease-in-out',
				'& .Mui-checked': {
					transform: 'scale(1.2)',
				},
			}}
		/>
	);
}
